import { useState } from 'react';
import { faqs } from '@/mocks/comics';

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-100 border-y border-background-200/60 scroll-mt-20">
      <div className="mx-auto max-w-3xl px-4 md:px-6 py-14 md:py-20">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500/15 px-3 py-1 text-xs font-semibold text-accent-600">
            <i className="ri-question-line"></i> 帮助中心
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl text-foreground-950">常见问题</h2>
          <p className="mt-2 text-sm text-foreground-500">关于麻瓜漫画网，你关心的都在这里</p>
        </div>

        <div className="mt-8 flex flex-col gap-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className="overflow-hidden rounded-xl bg-background-50 ring-1 ring-background-300/40"
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="text-sm font-semibold text-foreground-950">{f.q}</span>
                  <i
                    className={`text-primary-500 transition-transform ${isOpen ? 'rotate-180' : ''}`}
                    aria-hidden="true"
                  ></i>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm leading-7 text-foreground-600">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}